import React from 'react';
import { RemoveInspectionForm } from 'modules/components/layer12';
import { BasicFormModalLayout } from 'modules/components/layer13';

export type RemoveInspectionModalProps = {
  id: string;
  isVisible: boolean;
  handleClose: () => void;
};

export const FC = (props: RemoveInspectionModalProps) => {

  return (
    <BasicFormModalLayout.FC
      id={props.id}
      title='Remove inspection'
      subTitle='Enter details in order to save them to the system.'
      handleClose={props.handleClose}
      isVisible={props.isVisible}
    >
      <RemoveInspectionForm.FC
        id={props.id}
        handleClose={props.handleClose}
      />
    </BasicFormModalLayout.FC>
  );

};
